import React, { useState, useEffect } from "react";
import axios from "axios";
import Modal from 'react-bootstrap/Modal';
import Swal from 'sweetalert2'
import { Container, Row, Col, Form, Button, ProgressBar } from "react-bootstrap"
import exportValue from "../../apiconfig";
import Left_panel from '../Left_panel';
import Sub_header from '../Sub_header';
import '../../components/loader.css';
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import TablePagination from '@mui/material/TablePagination';
import ReactLoading from 'react-loading';

const Hub_management = () => {
    const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
    const[addzone ,setaddzone] = React.useState({name:"" , address:"" , mob_no:"" , email:"" , warehouse_name:""})
    const[state , setstate]=React.useState([])
    const [pincode, setPincode] = React.useState('');
const [newstate, setnewState] = React.useState('');
const [newcity, setnewCity] = React.useState('');
const [newstateid, setnewStateid] = React.useState('');
const [newcityid, setnewCityid] = React.useState('');
const[btnState,setbtnState] = React.useState(false)

    React.useEffect(()=>{
        group_list()
    },[])
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        const homeSection = document.querySelector('.home-section');
        if (homeSection) {
            homeSection.classList.toggle('sidebar-closed');
        }
    };
   

      const handleChange =(e)=>{
        setaddzone({...addzone , [e.target.name]:e.target.value})
      }
      const group_list = ()=>{
       
        let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/hub_management_list`;
        let sendData = { }
        
        axios.post(full_api, sendData, { headers: exportValue.headers }).then((res)=>{
             if(res.data.status == true){
                setstate(res.data.output)
             }
             else{
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3000
                })
  
                Toast.fire({
                    background: "#206bc4",
                    type: 'unsuccess',
                    title: "Something went wrong",
                    color: "white"
                });
             }
  
            }).catch((e) => {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3000
                })
  
                Toast.fire({
                    background: "#206bc4",
                    type: 'unsuccess',
                    title: "Something went wrong",
                    color: "white"
                });
  
            });
     
       }
       const addAddress = () => {
        setbtnState(false)
         
          let url = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/add_hub`;
             let sendData = { addzone , pincode,newcity , newstate , newcityid , newstateid };
             // console.log("bb", sendData);
             let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
             if ( re.test(addzone.email) ) {
             if(addzone.full_name!="" && addzone.email!=""  && pincode!="" && newcity!="" && addzone.address!="" && newstate!=""  && addzone.mobile!=""  && addzone.warehouse_name!="" ){
             axios.post(url, sendData, { headers: exportValue.headers }).then((res) => {
               if(res.data.status==true){
                  setbtnState(true)
                 const Toast = Swal.mixin({
                      toast: true,
                      position: 'bottom-end',
                      showConfirmButton: false,
                      timer: 3000
                    })
                    
                    Toast.fire({
                      background:"#3659cd",
                      type: 'success',
                      title: "Address Added Successfully",
                      color:"white"
                    });
                    window.location.reload()
                  
               }
               else{
                setbtnState(true)
               }
             }).catch((e) => {
            
  
              const Toast = Swal.mixin({
                  toast: true,
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000
                })
                
                Toast.fire({
                  background:"#a61c09",
                  type: 'unsuccess',
                  title: "Something Went Wrong",
                  color:"white"
                });
                setbtnState(true)
             });
          }
          
          else{
              const Toast = Swal.mixin({
                  toast: true,
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000
                })
                
                Toast.fire({
                  background:"#a61c09",
                  type: 'unsuccess',
                  title: "Please Fill All the Details",
                  color:"white"
                });
                setbtnState(true)
          }
      }else{
        const Toast = Swal.mixin({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000
          })
          
          Toast.fire({
            background:"#a61c09",
            type: 'unsuccess',
            title: "Please Fill Email In Correct Format",
            color:"white"
          });
          setbtnState(true)
      }
    
         }
       const fetchDetailsFromPincode = async (enteredPincode) => {
        try {
          // Replace 'your-api-endpoint' with the actual endpoint of your backend
          const url = exportValue.apiUrl + '/country/automate_pincode';
          
          // Assuming your API expects a POST request with the entered pincode
          const sendData = { enteredPincode , country_id: 244};
          console.log("sendData == " , sendData)
      
          const response = await axios.post(url, sendData);
      
          // Assuming your API returns an object with state and city properties
          const { state, city , state_id , city_id } = response.data;
      
          return { state, city , state_id , city_id };
        } catch (error) {
          console.error('Error fetching details:', error);
          return {
            state: '',
            city: '',
            state_id:'',
            city_id:'',
          };
        }
      };

       const handlePincodeChange = async (e) => {
        const newPincode = e.target.value;
    
        // Update pincode state
        setPincode(newPincode);
    
        // Check if the length is at least three characters
        if (newPincode.length >= 3) {
          // Fetch details based on the pincode
          const { state: newState, city: newCity , state_id: newStateid , city_id:newCityid } = await fetchDetailsFromPincode(newPincode);
    
          // Update state and city inputs
          setnewState(newState);
          setnewCity(newCity);
          setnewStateid(newStateid);
          setnewCityid(newCityid);
        } else {
          // Reset state and city if the pincode is less than three characters
          setnewState('');
          setnewCity('');
        }
      };

      

      const deleteHub = (hub) => {
          let url = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/delete_hub`;
             let sendData = { hub_id:hub.hub_id };
             // console.log("bb", sendData);
             axios.post(url, sendData, { headers: exportValue.headers }).then((res) => {
               if(res.data.status==true){
                 
                 const Toast = Swal.mixin({
                      toast: true,
                      position: 'bottom-end',
                      showConfirmButton: false,
                      timer: 3000
                    })
                    
                    Toast.fire({
                      background:"#3659cd",
                      type: 'success',
                      title: res.data.message,
                      color:"white"
                    });
                    window.location.reload()
                  
               }
               else{
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3000
                  })
                  
                  Toast.fire({
                    background:"#3659cd",
                    type: 'unsuccess',
                    title: res.data.message,
                    color:"white"
                  });
                
               }
             }).catch((e) => {
            
  
           
             });
          }
          
       
      
    
         
      
  return (
    <div>
      
    <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
     
     <section class="home-section">
            
     <Sub_header/>


<div style={{ marginLeft: "15px", marginRight: "15px" }}> 
  <section>
          <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
              <div class="d-block mb-4 mb-md-0">
                

                  <div class="d-flex">
                      <div class="">
                          <h2 class="h4">Add New Hub</h2>
                      </div>
                  </div>
              </div>
            
          </div>
          
  </section>

  <div class="modal" id="addnewpincode_special" data-bs-backdrop="false">
<div class="modal-dialog modal-lg">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Add Hub</h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal" ></button>
    </div>
    <div class="modal-body">
      <div class="mb-3 mt-3">
        <label for="" class="form-label">Name: <span class="text-danger">*</span></label>
        <input type="text" class="form-control" id="" placeholder="Enter Name" name="name" onChange={(e) => handleChange(e)}/>
      </div>
      <div class="mb-3 mt-3">
        <label for="" class="form-label">Address: <span class="text-danger">*</span></label>
        <textarea className="form-control" name="address" onChange={(e) => handleChange(e)}></textarea>
      </div>
      <div className="row">
            <div className="col-4">
            <label for="" class="form-label">Pincode: <span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="" placeholder="Enter Pincode" value={pincode}
       onChange={handlePincodeChange}/> 
            </div>
            <div className="col-4">
            <label for="" class="form-label">State: <span class="text-danger">*</span></label>
            <input className='form-control' type='text' disabled='disabled' value={newstate}></input>
            </div>
            <div className="col-4">
            <label for="" class="form-label">City: <span class="text-danger">*</span></label>
            <input className='form-control' type='text' disabled='disabled' value={newcity}></input>
            </div>

        </div>
        <div className="row mb-3 mt-3">
        <div class="col-4">
        <label for="" class="form-label">Mobile Number: <span class="text-danger">*</span></label>
        <input type="number" class="form-control" id="" placeholder="Enter Mobile Number" name="mob_no" onChange={(e) => handleChange(e)}/>
      </div>
      <div class="col-4">
        <label for="" class="form-label">Email: <span class="text-danger">*</span></label>
        <input type="email" class="form-control" id="" placeholder="Enter Email" name="email" onChange={(e) => handleChange(e)}/>
      </div>
      <div class="col-4">
        <label for="" class="form-label">Warehouse Name: <span class="text-danger">*</span></label>
        <input type="text" class="form-control" id="" placeholder="Enter Warehouse Name" name="warehouse_name" onChange={(e) => handleChange(e)}/>
      </div>
        </div>
       
    </div>
    <small className="ms-2">*IN WAREHOUSE NAME NEED TO CREATE WAREHOUSE FIRST ON DELHIVERY PORTAL AND THEN PASTE THAT WAREHOUSE NAME IN THIS FIELD</small>
     
    <div class="modal-footer">
      <a  class="btn btn-primary" onClick={(e)=>addAddress(e)} >Submit</a>
      <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
    </div>
  </div>
</div>
</div>
  <section>
      <div class="card border-0 shadow ">
        <div class="card-body">
          
  
        
              <div class="row mb-3">
                  
                  <div class="col-md text-end ">
                      <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#addnewpincode_special" data-bs-backdrop="false">Add Hub</button>
                      <a class="btn btn-primary ms-2" href="/assign_hub">Assign Hub</a>
                     
                     
                  </div>
              </div>
          
                <div class="card card-body border-0 shadow table-wrapper table-responsive">
              <table class="table table-hover table-sm shipm_tablew">
                  <thead>
                      <tr>
                          	
                          <th class="border-gray-200">Hub Name</th>
                          <th class="border-gray-200">Hub Address</th>
                          <th class="border-gray-200">Hub Pincode</th>
                          <th class="border-gray-200">Hub City</th>
                          <th class="border-gray-200">Hub State</th>
                          <th class="border-gray-200">Hub Mobile</th>
                          <th class="border-gray-200">Hub Email</th>
                          <th class="border-gray-200">Action</th>

                         



                      </tr>
                  </thead>

                  <tbody>
                      {state.map((sub , i)=>(
                      <tr>
                          <td>
                          {sub.hub_name}
                          </td>                     
                          <td>
                          {sub.hub_address}
                           </td> 
                           <td>{sub.hub_pincode}</td>
                           <td>{sub.hub_city}</td>
                           <td>{sub.hub_state}</td>
                           <td>{sub.hub_mobile}</td>
                           <td>{sub.hub_email}</td>
                           <td class="pin_delte">
                            <button type="button" onClick={(e)=>deleteHub(sub)} class="btn btn-danger btn-sm"><i class="material-icons-outlined pin_delte fs-12">delete</i> </button>
                        </td>

                         

                        </tr> 
                      ))}
                                          
                  </tbody>
                 
              </table>
          </div> 
       
        </div>
      </div>
  </section>
  </div>
  </section>
  </div>
  )
}

export default Hub_management
